import { render, staticRenderFns } from "./PrivateNurse.vue?vue&type=template&id=636922d5&scoped=true"
import script from "./PrivateNurse.vue?vue&type=script&lang=js"
export * from "./PrivateNurse.vue?vue&type=script&lang=js"
import style0 from "./PrivateNurse.vue?vue&type=style&index=0&id=636922d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636922d5",
  null
  
)

export default component.exports